import { AuthenticationFailed } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface LoginPayload {
  email: string;
  password: string;
}
export const login = createAction<LoginPayload>('LOGIN');
export type LoginActionType = Action<LoginPayload>;

interface LoginSuccessfulPayload extends TimestampPayload {
  token: string;
}
export const loginSuccessful = createAction<LoginSuccessfulPayload>('LOGIN_SUCCESSFUL');

export interface LoginFailedPayload extends TimestampPayload {
  authenticationFailed: AuthenticationFailed;
}
export const loginFailed = createAction<LoginFailedPayload>('LOGIN_FAILED');
